<template>
  <div class="wg-row">
    <template v-if="isMerging">
      <div class="wg-row" style="padding: 20px; justify-content: center">
        <vue-simple-spinner
          size="medium"
          line-fg-color="#0aabf4"
        ></vue-simple-spinner>
      </div>
    </template>
    <template v-else>
      <template v-if="!stepTwo">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Search contact", "Cerca contatto") }}
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <wg-search
            :mode="'offline'"
            :searchFn="searchContact"
            :clickFn="selectContact"
            :filters="searchFilters"
            :debounceTime="1000"
          ></wg-search>
        </div>
        <div class="wg-col wg-xs-12" v-if="contactSel">
          <div class="vertical-height-div" style="height: 15px"></div>
          <div
            class="wg-row display-flex"
            style="align-items: center; min-height: 50px"
          >
            <img
              style="width: 30px"
              :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
            />
            <div class="anm22-calendar-field-inline">
              <span class="contactName">{{ $anm22.getContactName(contactSel, $store) }}</span>
            </div>
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="cursor: pointer; margin-left: 5px"
              @click="contactSelected = null"
            />
          </div>
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Next ', 'Avanti')"
          :disabled="!contactSelected"
          :style="{ opacity: !contactSelected ? '0.6' : '' }"
          @click="stepTwo = true"
        />
      </template>
      <template v-else>
         <div
          class="wg-row display-flex"
          style="align-items: center; justify-content: center"
        >
          <img
            style="width: 30px"
            :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
          />
          <div class="anm22-calendar-field-inline">
            <span class="contactName">{{ $anm22.getContactName(contact, $store) }}</span>
            <span class="format">Created: </span><span>{{ contact.registrationDate | moment('DD MMM YYYY HH:mm') }}</span>
          </div>
        </div>
          <div class="wg-row" style="justify-content: center">
          <img
            style="width: 20px"
            :src="$anm22.icons.getWorldIcon('doubleArrowDown')"
          />
        </div>
        <div
          class="wg-row display-flex"
          style="align-items: center; justify-content: center"
        >
          <img
            style="width: 30px"
            :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
          />
          <div class="anm22-calendar-field-inline">
            <span class="contactName">{{ $anm22.getContactName(contactSel, $store) }}</span>
            <span class="format">Created: </span><span>{{ contactSel.registrationDate | moment('DD MMM YYYY HH:mm') }}</span>
          </div>
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <div class="wg-row" style="justify-content: center">
          <img
            style="width: 30px"
            :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
          />
        </div>
        <div style="padding: 20px">
          <div class="com-anm22-app-text-l">
            {{
              $anm22.strLang(
                lang,
                $anm22.getContactName(contact, $store) +
                  "'s" +
                  " " +
                  "data will be added to those already existing in" +
                  " " +
                  $anm22.getContactName(contactSel, $store),
                "I dati di" +
                  " " +
                  $anm22.getContactName(contact, $store) +
                  " " +
                  "verranno aggiunti quelli già esistenti in" +
                  " " +
                  $anm22.getContactName(contactSel, $store)
              )
            }}
          </div>
          <template v-if="contact.workOwner == 474 || contact.workOwner == 965">
            <div class="vertical-height-div" style="height: 5px"></div>
            <div class="com-anm22-app-text-l">
              {{
                $anm22.strLang(
                  lang,
                  "N.B. Any pricings associated with" +
                    " " +
                    $anm22.getContactName(contact, $store) +
                    " " +
                    "will be lost.",
                  "N.B. Eventuali condizioni economiche associate a" +
                    " " +
                    $anm22.getContactName(contact, $store) +
                    " " +
                    "andranno perse."
                )
              }}
            </div>
          </template>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="com-anm22-app-text-l">
            {{
              $anm22.strLang(
                lang,
                "The process is not reversible.",
                "Il processo non è reversibile."
              )
            }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <div
          class="wg-row"
          style="align-items: center; justify-content: center"
        >
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'Continue', 'Procedi')"
            @click="mergeContacts"
          />
          <div class="com-anm22-app-horizontal-space" style="width: 20px"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="stepTwo = false"
          />
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    contact: Object,
    mergeConfirmDialog: Boolean
  },
  data() {
    return {
      stepTwo: false,
      isMerging: false,
      contactSelected: null,
      showContact: false
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user
    }),
    searchFilters() {
      return [(contact) => this.contact.idContactsContact != contact.id];
    },
    contactSel() {
      return this.$store.getters["contacts/get"](this.contactSelected);
    },
    contacts() {
      return this.$store.getters["contacts/getAll"].filter(
        (c) =>
          c.workOwner == this.contact.workOwner && c.type == this.contact.type
      );
    }
  },
  methods: {
    mergeContacts() {
      this.isMerging = true;
      let contactToMerge = this.contact;
      let contactSelected = this.contactSel;

      // Unisco l'array dei links e elimino gli url uguali
      contactSelected.links = contactSelected.links
        .concat(contactToMerge.links)
        .filter(
          (link, index, arrayResult) =>
            arrayResult.findIndex((l) => l.link == link.link) === index
        );
      
      if (contactSelected.firstName == "") {
        contactSelected.fristName = contactToMerge.firstName;
      }
      if (contactSelected.lastName == "") {
        contactSelected.lastName = contactToMerge.lastName;
      }
      if (contactSelected.referrerFirstName == "") {
        contactSelected.referrerFirstName = contactToMerge.referrerFirstName;
      }
      if (contactSelected.referrerLastName == "") {
        contactSelected.referrerLastName = contactToMerge.referrerLastName;
      }
      if (contactSelected.status == "") {
        contactSelected.status = contactToMerge.status;
      }
      if (contactSelected.companyContact == "") {
        contactSelected.companyContact = contactToMerge.companyContact;
      }
      if (contactSelected.sdi == "") {
        contactSelected.sdi = contactToMerge.sdi;
      }
      if (contactSelected.vatCode == "") {
        contactSelected.vatCode = contactToMerge.vatCode;
      }
      if (contactSelected.taxCode == "") {
        contactSelected.taxCode = contactToMerge.taxCode;
      }
       if (contactSelected.lotteryCode == "") {
        contactSelected.lotteryCode = contactToMerge.lotteryCode;
      }
      if (contactSelected.fbPage == "") {
        contactSelected.fbPage = contactToMerge.fbPage;
      }
      if (contactSelected.twitter == "") {
        contactSelected.twitter = contactToMerge.twitter;
      }
      if (contactSelected.birthday == "") {
        contactSelected.birthday = contactToMerge.birthday;
      }
      if (contactSelected.commercialPrivacyPolicyDate == "") {
        contactSelected.commercialPrivacyPolicyDate = contactToMerge.commercialPrivacyPolicyDate;
      }
      if (contactSelected.privacyPolicyDate == "") {
        contactSelected.privacyPolicyDate = contactToMerge.privacyPolicyDate;
      }
      if(contactSelected.otherInformations ==[] && contactToMerge.otherInformations !==[]){

      }
      if (contactSelected.gender == "" || contactSelected.gender == 0) {
        contactSelected.gender = contactToMerge.gender;
      }
      if (contactSelected.mybusiness == "") {
        contactSelected.mybusiness = contactToMerge.mybusiness;
      }
      if (contactSelected.fbId == "") {
        contactSelected.fbId = contactToMerge.fbId;
      }
      if (contactSelected.company == "") {
        contactSelected.company = contactToMerge.company;
      }
      if (contactSelected.pec == "") {
        contactSelected.pec = contactToMerge.pec;
      }
      if (contactSelected.website == "") {
        contactSelected.website = contactToMerge.website;
      }
      if (contactSelected.abandoned == "") {
        contactSelected.abandoned = contactToMerge.abandoned;
      }
      if (contactSelected.leadChannel == "") {
        contactSelected.leadChannel = contactToMerge.leadChannel;
      }
      if (contactSelected.competitor == "") {
        contactSelected.competitor = contactToMerge.competitor;
      }
      if (
        !contactSelected.otherContacts ||
        contactSelected.otherContacts.length == 0
      ) {
        contactSelected.otherContacts = { emails: [], phones: [], job: "" };
      }
      if (
        !contactToMerge.otherContacts ||
        contactToMerge.otherContacts.length == 0
      ) {
        contactToMerge.otherContacts = { emails: [], phones: [], job: "" };
      }

      //Se il campo email del contatto selezionato è vuoto imposto l'email del contatto da unire come principale se presente,altrimenti lo unisco all'array otherContacts
      if (contactToMerge.email != "") {
        if (contactSelected.email == "") {
          contactSelected.email = contactToMerge.email;
        } else {
          if (
            contactSelected.otherContacts &&
            contactSelected.otherContacts.emails
          ) {
            //CONTROLLO EMAIL UGUALE NELLE ALTRE MAIL GIA PRESENTE
            let find = contactSelected.otherContacts.emails.find(
              (em) =>
                em.address.toLowerCase() == contactToMerge.email.toLowerCase()
            );
            if (!find) {
              contactSelected.otherContacts.emails.push({
                address: contactToMerge.email
              });
            }
          } else {
            contactSelected.otherContacts.emails = [];
            contactSelected.otherContacts.emails.push({
              address: contactToMerge.email
            });
          }
        }
      }
      if (
        contactToMerge.phoneAreaCode != "" &&
        contactToMerge.phoneNumber != ""
      ) {
        if (
          contactSelected.phoneAreaCode != "" &&
          contactSelected.phoneNumber == ""
        ) {
          contactSelected.phoneAreaCode = contactToMerge.phoneAreaCode;
          contactSelected.phoneNumber = contactToMerge.phoneNumber;
        } else {
          if (
            contactSelected.otherContacts &&
            contactSelected.otherContacts.phones
          ) {
            let find = contactSelected.otherContacts.phones.find(
              (phone) =>
                phone.phoneAreaCode == contactToMerge.phoneAreaCode &&
                phone.phoneNumber == contactToMerge.phoneNumber
            );
            if (!find) {
              contactSelected.otherContacts.phones.push({
                phoneAreaCode: contactToMerge.phoneAreaCode,
                phoneNumber: contactToMerge.phoneNumber
              });
            }
          } else {
            contactSelected.otherContacts.phones = [];
            contactSelected.otherContacts.phones.push({
              phoneAreaCode: contactToMerge.phoneAreaCode,
              phoneNumber: contactToMerge.phoneNumber
            });
          }
        }
      }
      if (
        contactToMerge.otherContacts.emails &&
        contactToMerge.otherContacts.emails.length > 0
      ) {
        if (!contactSelected.otherContacts.emails) {
          contactSelected.otherContacts.emails = [];
        }
        contactSelected.otherContacts.emails = contactSelected.otherContacts.emails
          .concat(contactToMerge.otherContacts.emails)
          .filter(
            (email, index, arrayResult) =>
              arrayResult.findIndex(
                (e) => e.address.toLowerCase() == email.address.toLowerCase()
              ) === index
          )
          .filter(
            (em) =>
              em.address.toLowerCase() != contactSelected.email.toLowerCase()
          );
      }
      if (
        contactToMerge.otherContacts.phones &&
        contactToMerge.otherContacts.phones.length > 0
      ) {
        if (!contactSelected.otherContacts.phones) {
          contactSelected.otherContacts.phones = [];
        }
        contactSelected.otherContacts.phones = contactSelected.otherContacts.phones
          .concat(contactToMerge.otherContacts.phones)
          .filter(
            (phone, index, arrayResult) =>
              arrayResult.findIndex(
                (p) =>
                  p.phoneAreaCode == phone.phoneAreaCode &&
                  p.phoneNumber == phone.phoneNumber
              ) === index
          )
          .filter(
            (phone) =>
              phone.phoneAreaCode + phone.phoneNumber !=
              contactSelected.phoneAreaCode + contactSelected.phoneNumber
          );
      }
      if (
        contactToMerge.otherContacts.job &&
        contactToMerge.otherContacts.job != ""
      ) {
        if (contactSelected.otherContacts.job == "") {
          contactSelected.otherContacts.job = contactToMerge.otherContacts.job;
        }
      }
      if(Array.isArray(contactSelected.otherInformations)){
        contactSelected.otherInformations = {};
      }
      if(contactToMerge.otherInformations.beachDimension) {
        if(!contactSelected.otherInformations.beachDimension) {
          contactSelected.otherInformations.beachDimension = contactToMerge.otherInformations.beachDimension;
        }
      }
      if(contactToMerge.otherInformations.addressCountry) {
        if(!contactSelected.otherInformations.addressCountry) {
          contactSelected.otherInformations.addressCountry = contactToMerge.otherInformations.addressCountry;
        }
      }
      if(contactToMerge.otherInformations.interestedTo) {
        if(!contactSelected.otherInformations.interestedTo) {
          contactSelected.otherInformations.interestedTo = {};
        }
        if(!contactSelected.otherInformations.interestedTo.beach) {
          contactSelected.otherInformations.interestedTo.beach = contactToMerge.otherInformations.interestedTo.beach;
        }
        if(!contactSelected.otherInformations.interestedTo.food) {
          contactSelected.otherInformations.interestedTo.food = contactToMerge.otherInformations.interestedTo.food;
        }
        if(!contactSelected.otherInformations.interestedTo.booking) {
          contactSelected.otherInformations.interestedTo.booking = contactToMerge.otherInformations.interestedTo.booking;
        }
        if(contactSelected.otherInformations.interestedTo.beach) {
          contactToMerge.otherInformations.interestedTo.beach = contactSelected.otherInformations.interestedTo.beach;
        }
        if(contactSelected.otherInformations.interestedTo.food) {
          contactToMerge.otherInformations.interestedTo.food = contactSelected.otherInformations.interestedTo.food;
        }
        if(contactSelected.otherInformations.interestedTo.booking) {
          contactToMerge.otherInformations.interestedTo.booking = contactSelected.otherInformations.interestedTo.booking;
        }
      }
      if(contactToMerge.otherInformations.restaurant && contactToMerge.otherInformations.hotel){
        if(!contactSelected.otherInformations.restaurant || !contactSelected.otherInformations.hotel){
          contactSelected.otherInformations.restaurant = contactToMerge.otherInformations.restaurant;
          contactSelected.otherInformations.hotel = contactToMerge.otherInformations.hotel;
        }
      }
      if(!contactToMerge.otherInformations.restaurant && contactToMerge.otherInformations.hotel){
        if(contactSelected.otherInformations.restaurant || !contactSelected.otherInformations.hotel){
          contactSelected.otherInformations.hotel = contactToMerge.otherInformations.hotel;
        }
      }
      if(contactToMerge.otherInformations.restaurant && !contactToMerge.otherInformations.hotel){
        if(!contactSelected.otherInformations.restaurant || contactSelected.otherInformations.hotel){
         contactSelected.otherInformations.restaurant = contactToMerge.otherInformations.restaurant;
        }
      }
      if(contactToMerge.referenceAgent) {
        if(!contactSelected.referenceAgent) {
          contactSelected.referenceAgent = contactToMerge.referenceAgent;
        }
      }
      if(contactToMerge.screenSalesAgent) {
        if(!contactSelected.screenSalesAgent) {
          contactSelected.screenSalesAgent = contactToMerge.screenSalesAgent;
        }
      }
      contactSelected.otherInformations.beachTabs = [...contactSelected.otherInformations.beachTabs||[], ...contactToMerge.otherInformations.beachTabs||[]];
      contactSelected.otherInformations.jobs = [...contactSelected.otherInformations.jobs||[], ...contactToMerge.otherInformations.jobs||[]];
      this.$http
        .post("contact/merge-contact", {
          contactSelected: contactSelected,
          contactToMerge: contactToMerge
        }, {
          withCredentials: true
        })
        .then((response) => {
          if (response.data) {
            Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                obj: response.data.contact
              }),
              this.$store.dispatch("contactPlaceAssocs/update", {
                vlf: this.$vlf("contactPlaceAssocs"),
                objs: response.data.contactPlaceAssocs
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places
              }),
              this.$store.dispatch("messages/update", {
                vlf: this.$vlf("messages"),
                objs: response.data.messages
              }),
            ])
              .then(() => {
                this.deleteContactAfterMerge(contactToMerge);
                this.$router.push({ path: `/contact/${this.contactSelected}` });
              })
              .catch((error) => console.log(error));
          }
        })
        .catch((error) => console.log(error));
    },
    deleteContactAfterMerge(contact) {
      this.$http
        .post("contact/delete-contact-merged", {
          contactId: contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then((response) => {
          if (response.data.contact) {
            Promise.all([
              ...contact.places.map((p) =>
                this.$store.dispatch("places/delete", {
                  vlf: this.$vlf("places"),
                  obj: this.$store.getters["places/get"](p)
                })
              ),
              this.$store.dispatch("contacts/delete", {
                vlf: this.$vlf("contacts"),
                obj: response.data.contact
              }),
            ]).then(() => {
              this.isMerging = false;
              this.$anm22.eventBus.$emit("wg-modal-close");
              this.$anm22.eventBus.$emit("world-headbar-show-message", {
                text: this.$anm22.strLang(
                  this.lang,
                  "Contact merge completed successfully",
                  "Unione contatti completata con successo"
                ),
                type: "suggestion"
              });
            });
          }
        })
        .catch((error) => console.log(error));
    },
    searchContact(string) {
      const regexp = new RegExp(string, "i");
      return this.contacts
        .filter((c) => {
          return -1 !== (c.firstName + " " + c.lastName).search(regexp);
        })
        .map((c) => {
          const fullname = c.firstName + " " + c.lastName;
          return {
            label: fullname,
            id: c.idContactsContact
          };
        });
    },
    selectContact(idContact) {
      this.contactSelected = idContact;
      this.showContact = true;
    }
  },
  components: {
    "vue-simple-spinner": Spinner
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.format{
  color: green;
  font-weight: bold;
}
.contactName{
  font-weight: bold;
}
</style>
